import { CurrencyOrEmpty } from '@plato/app-shared/components/currency-or-empty';
import SmallSpinner from '@plato/ui-legacy/components/ui/small-spinner';
import { ProgressBar } from '@tremor/react';
import { useTranslation } from 'react-i18next';
import { api } from '../../../utils/api.ts';
import { Can } from '../../acl/can.tsx';
import { useAcl } from '../../acl/use-acl.ts';

export type CustomerDetailCreditLimitProps = {
    compact?: boolean;
    customerId: string;
};

export function CustomerDetailCreditLimit({ compact, customerId }: CustomerDetailCreditLimitProps) {
    const { t } = useTranslation();
    const acl = useAcl();

    const { data: creditLimit, isLoading: isLoadingCreditLimit } =
        api.platoUser.grid.getCreditLimit.getForCustomer.useQuery(
            { customerId },
            {
                // Prevents the query from running if the user doesn't have the required permissions,
                enabled: acl.can('read', 'CustomerCreditLimit'),
            },
        );

    const formattedLimit = (
        <>
            <CurrencyOrEmpty decimals={2}>{creditLimit?.used_limit}</CurrencyOrEmpty>
            {` / `}
            <CurrencyOrEmpty decimals={2}>{creditLimit?.credit_limit}</CurrencyOrEmpty>
        </>
    );

    return (
        <Can I="read" a="CustomerCreditLimit">
            {compact ? (
                formattedLimit
            ) : (
                <div className="flex flex-1 flex-col justify-start rounded-md bg-neutral-50 p-3">
                    <div className="text-sm font-normal text-neutral-500">
                        {t('credit__title', { ns: 'customer-detail' })}
                    </div>
                    {creditLimit && (
                        <>
                            <div className="flex h-full items-center text-sm font-normal text-neutral-800 ">
                                {formattedLimit}
                            </div>
                            <ProgressBar value={creditLimit.percentage_used_limit} />
                        </>
                    )}
                    {isLoadingCreditLimit && (
                        <div className="flex h-full items-center justify-center">
                            <SmallSpinner />
                        </div>
                    )}
                </div>
            )}
        </Can>
    );
}
